import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/configureStore";

declare global {
  interface Window {
    fwcrm?: {
      on: (event: string, callback: () => void) => void;
    };
    fcWidget?: {
      setExternalId: (id: string) => void;
      user: {
        setFirstName: (name: string) => void;
        setEmail: (email: string) => void;
        setProperties: (properties: Record<string, string>) => void;
      };
    };
  }
}

const FreshchatWidget = () => {
  const userState = useSelector((state: RootState) => state?.malaeb?.user_data);
  const id = useSelector((state: RootState) => state?.malaeb?.user_uuid);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//fw-cdn.com/15187220/6610214.js";
    script.setAttribute("chat", "true");
    script.async = true;

    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    if (!userState || !id) return;

    const identifyUser = () => {
      if (typeof window !== "undefined" && window.fwcrm && window.fcWidget) {
        const { name, email, phone_number } = userState;
        const fcWidget = window.fcWidget;

        window.fwcrm.on("user:created", function () {
          const widget = window.fcWidget;
          if (!widget) return;

          if (id) {
            widget.setExternalId(id);
          }

          if (name) {
            widget.user.setFirstName(name);
          }

          if (email) {
            widget.user.setEmail(email);
          }

          const properties: Record<string, string> = {};
          if (phone_number) {
            properties.phone_number = phone_number;
          }

          if (Object.keys(properties).length > 0) {
            widget.user.setProperties(properties);
          }
        });
      }
    };

    if (typeof window !== "undefined" && window.fwcrm && window.fcWidget) {
      identifyUser();
      return;
    }

    const checkFreshchat = setInterval(() => {
      if (typeof window !== "undefined" && window.fwcrm && window.fcWidget) {
        identifyUser();
        clearInterval(checkFreshchat);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkFreshchat);
    }, 10000);

    return () => {
      clearInterval(checkFreshchat);
    };
  }, [userState, id]);

  return null;
};

export default FreshchatWidget;
